import { render } from "./YamlEditor.vue?vue&type=template&id=3e6a35ee"
import script from "./YamlEditor.vue?vue&type=script&lang=js"
export * from "./YamlEditor.vue?vue&type=script&lang=js"

import "./YamlEditor.vue?vue&type=style&index=0&id=3e6a35ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__